import { render, staticRenderFns } from "./OrdersStackedLine.vue?vue&type=template&id=05d2b336&"
import script from "./OrdersStackedLine.vue?vue&type=script&lang=js&"
export * from "./OrdersStackedLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports